import { Column } from 'typeorm';
import type { TradeShowAttendAs, TradeShowNextEditionAction } from '../../constants/trade-shows';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * Settings → Trade shows (PD-17632): which directory shows to suggest, and what
 * the tenant lets Workd use to keep the directory current. One row per tenant.
 * Both sharing settings start off: nothing leaves a tenant until it says so.
 */
@Entity('trade_show_preference')
export class TradeShowPreferenceEntity extends BaseEntity {
	@Column('json', { name: 'sectors', nullable: true })
	public sectors?: Array<string> | null;

	@Column('int', { name: 'radiusMiles', unsigned: true, default: 500 })
	public radiusMiles!: number;

	@Column('varchar', { name: 'attendAs', length: 30, default: 'exhibitor_and_attendee' })
	public attendAs!: TradeShowAttendAs;

	@Column('boolean', { name: 'rankByCustomers', default: 1 })
	public rankByCustomers!: boolean;

	@Column('boolean', { name: 'rankByCompetitors', default: 1 })
	public rankByCompetitors!: boolean;

	@Column('boolean', { name: 'includeSupplierShows', default: 0 })
	public includeSupplierShows!: boolean;

	@Column('varchar', { name: 'nextEditionAction', length: 20, default: 'add_interested' })
	public nextEditionAction!: TradeShowNextEditionAction;

	@Column('boolean', { name: 'shareCorrections', default: 0 })
	public shareCorrections!: boolean;

	@Column('boolean', { name: 'shareExhibitors', default: 0 })
	public shareExhibitors!: boolean;

	/**
	 * PD-17636: business types kept for the record but left out of campaigns.
	 * Null until a tenant sets them, which reads as the default list.
	 */
	@Column('json', { name: 'notTargetTypes', nullable: true })
	public notTargetTypes?: Array<string> | null;
}
